var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "entity-list-layout",
    {
      staticClass: "admin-organization-list",
      attrs: {
        title: "ORGANIZATION",
        count: _vm.organizations.length,
        query: _vm.search,
        "search-hint": _vm.$t("label.search"),
      },
      on: {
        "update:query": function ($event) {
          _vm.search = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "title-area-content",
          fn: function () {
            return [
              _vm.showsManagedBy
                ? _c("managed-by-select", {
                    staticClass: "admin-organization-list__managed-by-select",
                    attrs: { distributors: _vm.distributors },
                    model: {
                      value: _vm.managedBy,
                      callback: function ($$v) {
                        _vm.managedBy = $$v
                      },
                      expression: "managedBy",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "round-button",
                {
                  staticClass: "my-2 mx-md-2",
                  attrs: { icon: "add_circle", to: "/admin/organizations/new" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("label.add_organization")) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "p-data-list",
        {
          attrs: { data: _vm.organizations, pagination: _vm.pagination },
          on: {
            "update:pagination": function ($event) {
              _vm.pagination = $event
            },
          },
        },
        [
          _c("data-field", {
            attrs: { name: "No", headerClass: "column--no" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(_vm._s(props.index + 1))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: { name: _vm.$t("field.name"), value: "name", sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "admin-organization",
                            params: { id: props.item.id },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(props.item.name) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.address"),
              value: "address",
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(_vm._s(props.item.address))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.phone_number"),
              value: "phone_number",
              headerClass: "column--phone-number",
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(_vm._s(props.item.phone_number))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.admin_user"),
              value: "admin.name",
              headerClass: "column--admin-user",
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    props.item.admin
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "admin-account",
                                params: { email: props.item.admin.email },
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(props.item.admin.name) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c("div", { staticClass: "text-center" }, [
                          _vm._v("---"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm.showsManagedBy
            ? _c("data-field", {
                attrs: {
                  name: _vm.$t("field.managed_by"),
                  value: "managedBySortKey",
                  headerClass: "column--managed-by",
                  sortable: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          props.item.managedByName
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "admin-organization-list__managed-by",
                                  class: {
                                    "text--disabled":
                                      props.item.managedByIsDirect,
                                  },
                                },
                                [_vm._v(_vm._s(props.item.managedByName))]
                              )
                            : _c(
                                "span",
                                {
                                  attrs: { "data-testid": "managed-by-empty" },
                                },
                                [_vm._v("--")]
                              ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1672961964
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }